import { render, staticRenderFns } from "./SidebarRole.vue?vue&type=template&id=204f6963&scoped=true"
import script from "./SidebarRole.vue?vue&type=script&lang=js"
export * from "./SidebarRole.vue?vue&type=script&lang=js"
import style0 from "./SidebarRole.vue?vue&type=style&index=0&id=204f6963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f6963",
  null
  
)

export default component.exports